import {
  findThePaperByEvaluationId,
  findSubsectionDetailsById,
  findQuestionDetailsById,
  findCandidateResult,
  findTestTrackName,
  getReportThemeDetailsFromTopic,
} from 'gql/query'
import { dataFormatTagBase } from './findingItemsTagbase'
import { changeformat } from './sectionBasedFormat'
import { sectionWiseChartReportData } from './sectionWiseChartData'
import { findNationalAverage } from './nationalAverage'
import { ISubsection } from 'type'
import { findthePercentage } from './findthePercentage'
import { candidateResponseByAnswers } from './candidateAnswersByResponse'
import { findSectionLevelPercentage } from './findTheSectionLevelPercentage'

export const changeDateFormat = async (newDate: any) => {
  const date = new Date(newDate)
  const day = date.getDate().toString().padStart(2, '0')
  const month = (date.getMonth() + 1).toString().padStart(2, '0') // Month is zero-based
  const year = date.getFullYear()
  const formattedDate = `${day}-${month}-${year}`
  return formattedDate
}

export async function getDateTwoYearsFromNow(projectType: string, issue_date: any) {
  const currentDate = issue_date ? new Date(issue_date) : new Date()
  const twoYearsFromNow = new Date(currentDate)
  if (projectType === 'jharkhand') {
    twoYearsFromNow.setMonth(currentDate.getMonth() + 6)
  } else {
    twoYearsFromNow.setFullYear(currentDate.getFullYear() + 2)
  }
  return twoYearsFromNow
}

export const reportDataGenerating = async (record: any, totalMarkForPaper: any) => {
  try {
    // console.log(record,totalMarkForPaper,"arguments")
    //finding the papertemplate Id and questions in each subsection
    const evaluationDetails: any = await findThePaperByEvaluationId(record?.evaluation_id)
    const candidateID = record?.candidate_id
    const candidataAnswers: any = await findCandidateResult(candidateID, record?.evaluation_id)
    const candidateResultArrayForEachQuestion = await candidataAnswers?.evaluation_details[0].answers
    // console.log(candidataAnswers,"candidateResultArrayForEachQuestion")
    const details = evaluationDetails?.evaluations[0]
    const answersKey = details?.paper?.questionAnswerKeys
    // const testDate=await changeDateFormat(details?.created_at)
    // const dateOfIssue= await changeDateFormat(Date.now())
    // const validityDate =await changeDateFormat(getDateTwoYearsFromNow());
    const testTrackDetails: any = await findTestTrackName(details?.paper?.test_track_id)
    const testTrackName = testTrackDetails.test_tracks[0].name
    const paperSubsectionDetails: ISubsection[] = []
    let subjectName = ''
    const productId = details?.paper?.product_id
    const testTrackId = details?.paper?.test_track_id
    if (details) {
      // console.log(productId,"productId",testTrackId,"testTrackId")
      // const getNationalAverage= await findNationalAverage(productId,testTrackId)
      console.log(details?.paper, 'paper details')
      const paperSubsectionsWithItsIds = details?.paper?.subSectionQuestions
      const candidateAllResponse: any = await candidateResponseByAnswers(candidateResultArrayForEachQuestion, answersKey, totalMarkForPaper)
      const { percentageOfMostWrong, percentageOfCloseToCorrect, percentageOfBlankResponse } = candidateAllResponse
      for (let i = 0; i < paperSubsectionsWithItsIds?.length; i++) {
        let response: any = await findSubsectionDetailsById(paperSubsectionsWithItsIds[i]?.id)
        let subsectionDetails = response?.paper_template_sub_sections[0]
        const subsectionObject: ISubsection = {
          subsection: subsectionDetails,
          question: [],
        }
        paperSubsectionDetails.push(subsectionObject)
        console.log(subsectionObject, 'subsection details')
        for (let j = 0; j < paperSubsectionsWithItsIds[i].questionIds.length; j++) {
          let qstnResponse: any = await findQuestionDetailsById(paperSubsectionsWithItsIds[i].questionIds[j])
          const questionDetails = qstnResponse?.questions[0]
          if (!subjectName) {
            subjectName = questionDetails?.subject?.name || ''
          }

          // below code block is for taking the RT from topic which will come from the subsection. if RT is not present (for old scenarios) then it will use the previous RT workflow
          if (subsectionDetails && subsectionDetails?.report_theme && subsectionDetails?.report_theme?.id) {
            questionDetails.report_theme = { id: subsectionDetails?.report_theme?.id, name: subsectionDetails?.report_theme?.name }
          } else {
            //finding the report theme from topic
            const getReportThemeDetails: any = await getReportThemeDetailsFromTopic(questionDetails?.theme?.id)
            questionDetails.report_theme = getReportThemeDetails.report_themes[0]
              ? { id: getReportThemeDetails.report_themes[0].id, name: getReportThemeDetails.report_themes[0].name }
              : null
          }
          // below code block is for taking the RT from subsection directly
          // questionDetails.report_theme = subsectionDetails?.report_theme
          //   ? { id: subsectionDetails?.report_theme?.id, name: subsectionDetails?.report_theme?.name }
          //   : null
          questionDetails.candidateResult = candidateResultArrayForEachQuestion.shift()
          paperSubsectionDetails[i].question?.push(questionDetails)
        }
      }

      //groping all the subsection by section name
      const sectioningFormatedData = await changeformat(paperSubsectionDetails)
      //separating with all tags and finding all tags with questions, mark and how much they obtaine
      // console.log(sectioningFormatedData,"section wise formated data")
      const findingTheTags = await dataFormatTagBase(sectioningFormatedData)
      const bloomLevelDataToChart = await findthePercentage(findingTheTags)
      const sectionWiseReportData = await sectionWiseChartReportData(findingTheTags)
      const sectionLevelDetails = await findSectionLevelPercentage(findingTheTags)
      return {
        findingTheTags,
        sectionWiseReportData,
        bloomLevelDataToChart,
        testTrackName,
        percentageOfMostWrong,
        percentageOfCloseToCorrect,
        percentageOfBlankResponse,
        sectionLevelDetails,
        subjectName,
        productId,
        testTrackId,
        is_attended: candidataAnswers?.evaluation_details[0].is_attended,
        is_eligible_for_result: candidataAnswers?.evaluation_details[0].is_eligible_for_result,
      }
    } else {
      return { error: true }
    }
  } catch (err) {
    console.log(err, 'error from data generating')
  }
}
